<template lang="html">
  <div class="listview-panes">
    <div class="list-pane">
      <div class="journal-label">
        <h2 title="Change Journal" @click="$modal.show('change-journal')">
          <div class="fas fa-book"></div>
            {{$parent.currentJournal}}
          <div class="fas fa-caret-down"></div>
        </h2>
      </div>
      <div class="entry-list">
        <div v-for="(entry, index) in getSortedEntries()" :key="entry.uuid"
        class="entry" @click="setActiveEntry(index)" :class="{'selected':entry.uuid == selectedEntry.uuid}">
          <div class="color-bar"></div>
          <div class="entry-date-display">
            <div class="day">{{entry.forDate.getDate()}}</div>
            <div class="month">{{entry.getMonthName()}}</div>
          </div>
          <div class="entry-info">
            <div class="entry-title">
              <h3>{{ entry.getPreviewLine() }}</h3>
            </div>
            <div class="entry-metrics">
              <!-- <v-tag-list v-model="entry.tags" theme="materialize" :removable="false"></v-tag-list> -->
              <i class="fas fa-tags" v-if="entry.tags.length"></i>&nbsp;<i>{{ entry.tags.join(', ') }}</i>
              <span v-if="!entry.tags.length">{{ entry.getPreviewLine(1) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="preview-pane">
      <vue-markdown class="text" :source="selectedEntry.content"></vue-markdown>
      <div class="entry-actions">
        <span @click="$parent.openEditorToDate(selectedEntry.forDate)"><i class="fas fa-edit"></i>&nbsp;Edit</span>
        <span @click="deleteEntry(selectedEntry.forDay)"><i class="fas fa-trash"></i>&nbsp;Delete</span>
      </div>

    </div>

    <modal name="change-journal" height="350" :classes="['change-journal-modal', 'v--modal']">
      <div class="journal-label">
        <h2>{{ $root.data.user.name }}'s Journals</h2>
      </div>
      <div class="journal-list">
        <div v-for="(journal, name) in $root.data.journals" :key="name"
        class="journal-item" :class="{'selected':journal.name == $parent.currentJournal}"
        @click="changeJournal(journal.name)">

          <b>{{journal.name}}</b> <br>
          {{Object.keys(journal.entries).length}} {{ Object.keys(journal.entries).length == 1 ? 'entry' : 'entries' }}  -
          Last Modified: {{ lastModified(journal) }}
        </div>
        <div class="journal-item" @click="createJournal('show')">
          Create New Journal...
        </div>
      </div></modal>
    <modal name="create-journal" :classes="['create-journal-modal', 'v--modal']">
      <div class="journal-label">
        <h2>Create New Journal</h2>
      </div>
      <div class="journal-create-form">
        <label>Journal Name</label>
        <vue-input v-model="newJournalName" ref="newJournalName" :placeholder="$root.data.user.name.split(' ')[0]+'\'s 2nd Journal'"></vue-input>
        <div class="form-spacer"></div>
        <label>Default Text</label>
        <vue-input :value="newJournalDefault" v-model="newJournalDefault" placeholder="## Heading"></vue-input>
        <div class="form-spacer"></div>
        <div class="align-right">
          <vue-button type="success" :disabled="!newJournalName" class="create-button" @click="createJournal()">
            <i class="fas fa-plus"></i> Create
          </vue-button>
        </div>
      </div>
    </modal>

  </div>
</template>

<script>
import VueMarkdown from 'vue-markdown';
import VTagList from 'v-tag-list';

export default {
  name: 'ListView',
  components: {
    VueMarkdown,
    VTagList
  },
  data: function() {
    return {
      selectedEntry: {
        content: ''
      },
      newJournalName: '',
      newJournalDefault: '',
    }
  },
  watch: {
    newJournalName: function(newVal, oldVal) {
      if (newVal.length > 30) {
        this.newJournalName = oldVal
      }
    },
    entryList: function() {
      this.setSelectedEntry()
    }
  },
  mounted: function() {
    this.setSelectedEntry()
  },
  methods: {
    getSortedEntries: function() {
      // sort entry list in reverse chronological order
      var el = this.$parent.journal.entries
      if (Object.keys(el).length == 0) {
        return []
      }
      return Object.values(el).sort((a, b) => (a.forDate < b.forDate) ? 1 : -1)
    },
    setActiveEntry(index) {
      this.selectedEntry = this.getSortedEntries()[index]
    },
    changeJournal(name) {
      this.$parent.currentJournal = name;
      this.$modal.hide('change-journal');
    },
    createJournal(arg) {
      if (arg == 'show') {
        this.$modal.show('create-journal');
        var b = this;
        setTimeout(function() {
          b.$refs.newJournalName.$el.children[0].maxLength = 30;
          b.$modal.hide('change-journal');
        }, 50);
      } else {
        if (!this.newJournalName) {
          return
        }
        this.$parent.createJournal(this.newJournalName, this.newJournalDefault.replace(/\\n/g, '\n'))
        this.$parent.currentJournal = this.newJournalName;
        this.$modal.hide('create-journal')
        this.newJournalName = '';
        this.newJournalDefault = '';
      }
    },
    lastModified(journal) {
      if (Object.keys(journal.entries).length == 0) {
        return 'Never'
      } else {
        return Object.values(journal.entries).sort(
          (a, b) => (b.modifiedDateTime > a.modifiedDateTime) ? 1 : -1)[0].modifiedDateTime.toLocaleString()
      }
    },
    setSelectedEntry() {
      if (this.$parent.journal.entries.hasOwnProperty(this.$parent.date.dateString())) {
        this.selectedEntry = this.$parent.journal.getEntry(this.$parent.date.dateString())
        return
      }
      var sortedEntries = this.getSortedEntries()
      if (sortedEntries.length == 0) {
        this.selectedEntry = {
          content: ''
        }
      } else {
        this.selectedEntry = sortedEntries[0];
      }
    },
    deleteEntry(forDay) {
      if (prompt('Type "DELETE" in the box to confirm permanent deletion of entry on ' + forDay + '.') == "DELETE") {
        this.$parent.journal.forcePurge(forDay)
        this.$parent.forceSave()
        this.$forceUpdate();
        this.setSelectedEntry();
      }
    }
  }
}
</script>

<style lang="css" scoped>
.main {
  background: #ffffff;
}
.listview-panes {
  display: grid;
  grid-template-columns: 501px minmax(0,1fr);
  grid-template-rows: minmax(0,1fr);
  grid-template-areas: "list-pane preview-pane";
  width: 100%;
  transition: 1.2s ease-in-out;
}
.listview-panes.focus-view {
  transform: translateX(-500px);
  width: calc(100% + 500px);
  transition: 1.2s ease-in-out;
}

.list-pane {
  grid-area: list-pane;
  border-right: 1px solid grey;
}

.preview-pane {
  grid-area: preview-pane;
  padding: 20px;
  /* background: #e4e4e4; */
  user-select: text;
}

.preview-pane > .text {
  height: calc(100% - 26px);
  overflow-y: auto;
}
.preview-pane .entry-actions {
  color: var(--dark);
  text-align: right;
  margin-top: 5px;
}
.preview-pane  .entry-actions > span {
  /* margin: 0 10px; */
  /* background: rgb(205, 205, 205);
  padding: 2px;
  border-radius: 2px; */
  display: inline-block;
  height: 26px;
  background-color: #e4e4e4;
  padding: 0 10px;
  border-radius: 13px;
  line-height: 26px;
  margin-left:10px;
  cursor: pointer;
}
/* .preview-pane > .text > *:first-child {
  padding-top: 0px;
  margin-top: 0px;
} */

.entry-list {
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100% - 67px);
}

.entry {
  border-bottom: 1px solid grey;
  height: 100px;
  display: flex;
  cursor: pointer;
}
.entry:hover {
  background: #f0f0f0;
}
.entry:hover > div {
  left: -5px;
  transition: left .2s ease-in-out;
}
.entry.selected > .color-bar {
  background: var(--shade3);
}
.entry > .color-bar {
  background: var(--shade0);
  width: 10px;
  height: 100%;
}
.entry > div {
  position: relative;
  left: -10px;
  transition: left .4s ease-in-out;
}
.entry.selected > div{
  left: 0px;
  transition: left .4s ease-in-out;
}
.entry > .entry-date-display {
  display: flex;
  width: 100px;
  text-align: center;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  height: 100%;
  color: var(--shade0);
}
.entry.selected > .entry-date-display {
  color: var(--shade2);
}
.entry > .entry-date-display > .day {
  font-size: 2em;
  margin-bottom: -.3em;
}
.entry > .entry-date-display > .month {
  font-size: 1em;
  text-transform: uppercase;
}
.entry > .entry-info {
  width: 375px;
  height: calc(100% - 20px);
  padding: 10px 25px 10px 0px;
}
.entry-info > .entry-title > h3 {
  margin: 0px;
  font-weight: 500;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.entry-info > .entry-metrics,
.entry-info > .entry-actions {
  font-weight: 300;
}
.entry-info > .entry-metrics {
  color: #3b3b3b;
  font-size: .9em;
}


.journal-label {
  color: #3b3b3b;
  padding: 15px;
  height: 37px;
  border-bottom: 1px solid grey;
  cursor: pointer;
}
.journal-label > h2 {
  margin: 0px;
  font-size: 25px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.journal-label .fa-book {
  margin: 0 5px 0 10px;
}


.change-journal-modal > .journal-label, .create-journal-modal > .journal-label {
  cursor: default;
  border-bottom: 2px solid dimgrey;
}
.change-journal-modal > .journal-list {
  height: calc(100% - 68px);
  overflow-y: auto;
}
.change-journal-modal > .journal-list > .journal-item {
  font-size: 1em;
  height: 3em;
  padding: 1em;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  border-bottom: 1px solid darkgrey;
  cursor: pointer;
  font-weight: 300;
}
.change-journal-modal > .journal-list > .journal-item:hover {
  background: #f0f0f0;
}
.change-journal-modal > .journal-list > .journal-item.selected > b::after {
  content: 'current';
  margin-left: 5px;
  padding: .1em .5em;
  border-radius: 1em;
  font-size: small;
  vertical-align: text-top;
  color: white;
  background: var(--shade0);
}
.change-journal-modal > .journal-list > .journal-item:last-child {
  height: 1.5em;
  padding: 1.75em 1em;
  /* text-align: right; */
}


.create-journal-modal > .journal-create-form {
  padding: 10px 20px 10px 20px;
}
.create-journal-modal > .journal-create-form > div {
  width: 100%;
}
.create-journal-modal > .journal-create-form > .form-spacer {
  height: 16px;
}
.align-right {
  text-align: right;
}
</style>
<style lang="css">
@import '../../assets/styles/chips.css'
</style>
